import { Routes } from "@angular/router";
import { SetupComponent } from "./components/setup/setup.component";
import { QRGeneratorComponent } from "./components/qr-generator/qr-generator.component";
import { MeetingRoomKioskComponent } from "./components/meeting-room-kiosk/meeting-room-kiosk.component";

export const routes: Routes = [
  {
    path: "",
    pathMatch: "full",
    redirectTo: "setup",
  },
  {
    path: "setup",
    component: SetupComponent,
  },
  {
    path: "qr-code",
    component: QRGeneratorComponent,
  },
  {
    path: "rooms/:meetingRoomId",
    component: MeetingRoomKioskComponent,
  },
  {
    path: "**",
    redirectTo: "setup",
  },
];
